import React from "react";

const About = () => {
  return (
    <>
      <div className="md:pt-28 lg:pt-32 xl:pt-28 pt-28 font-avenir">
        <div>
          <div className="mb-10 container mx-auto font-avenir">
            <div className="grid md:grid-cols-2 md:px-10 px-5">
              <div className="flex justify-center md:text-start flex-col gap-3 md:pl-7 md:pr-10 mt-10">
                <h2 className="md:text-[40px] text-3xl font-semibold">
                  About ClevDoc
                </h2>
                <p className="md:text-justify text-xl tracking-wide">
                  ClevDoc was founded in 2020 with a simple observation: some of
                  the most important processes in banking and law still run on
                  outdated, generic software, or no digital tools at all. We
                  started by focusing closely on two of these: how banks
                  communicate with borrowers during recovery, and how
                  arbitration cases get managed from filing to resolution.
                </p>
              </div>
              <div className="grid place-items-center">
                <div className="container mx-auto px-5 py-2 md:pt-24">
                  <div className="flex items-center">
                    <img
                      src="https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.04.05+PM.jpeg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mx-16 text-justify  tracking-wide">
              <p className="text-xl">
                Rather than building one broad platform to do everything, we've
                chosen to build focused products for specific problems. Our
                Banking Communication Platform and Virtual Arbitration Platform
                are shaped around how these processes actually work, not a
                generic template stretched to fit. We're based in Gurugram, and
                we're still early, but the goal hasn't changed: build software
                for processes that deserve more than what they currently have.
              </p>
            </div>
          </div>
          <div className="bg-bgclr8 shadow-lg">
            <div className="grid md:grid-cols-2 mx-auto gap-10 container py-8 mt-2 mb-10">
              <div className="flex items-center">
                <img
                  src="https://cdn.clevdoc.com/assets/about/aboutImg_2.png"
                  alt=""
                />
              </div>
              <div className="md:px-7 px-5">
                <p className="md:text-justify text-center text-xl">
                  Our work aligns closely with the Digital India and Make in
                  India vision. We build software specifically for how
                  institutions in India actually work, rather than adapting
                  something generic built for a different market. Part of that
                  means paying attention to the realities that don't always show
                  up in software built elsewhere: how institutions here are
                  structured, how compliance actually works on the ground, and
                  what it takes for smaller or less tech-savvy organizations to
                  adopt something new without a large IT team behind them. We
                  also see this as part of a larger shift already underway,
                  where more of India's institutions are moving away from manual
                  processes altogether, and we'd rather be building the tools
                  for that shift than watching it happen.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container mx-auto py-10 mb-10 md:px-20 px-5 font-avenir">
          <div className="mt-5 md:py-20 py-12 md:px-10 bg-bgclr8 border">
            <div className="justify-center">
              <h1 className="md:text-4xl text-2xl text-center font-semibold">
                Get to Know Us
              </h1>
            </div>
            <p className="text-md text-center font-semibold">
              Empowering your dreams
            </p>
            <div className="flex items-center justify-center">
              <p className="md:px-20 px-3 md:text-justify text-center text-xl text-gray-700 md:p-8 ">
                Our team of experienced technologists, business strategists, and
                innovation leaders is dedicated to solving complex challenges
                through the intelligent use of cutting-edge technologies. From
                streamlining operations with AI and automation to enhancing
                system performance and security with modern architecture and
                engineering practices, we build scalable, resilient, and
                efficient digital solutions. Our mission is to help
                organizations accelerate digital transformation, drive
                operational excellence, and stay competitive in a rapidly
                evolving landscape. By fostering cross-functional collaboration,
                adopting agile methodologies, and staying ahead of emerging
                trends, we’re shaping a future where technology drives
                sustainable success.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default About;
